import { IContentItem } from '../interfaces';
import { Video, ContentItem } from '..';
import { ContentItemType } from '@/store/enums/';
import { IAnswer } from '../interfaces/answer.interface.dto';
import { Answer } from '../answer.dto';
import { IConvoState } from '@/store/modules/convo-details';

export class VideoContentItemFactory {
    make(obj: Video, state: IConvoState): IContentItem {
        const contentItem = new ContentItem();
        contentItem.id = obj.id;
        contentItem.sort = obj.sort;
        contentItem.attachment = JSON.stringify(obj.video);
        contentItem.tags = obj.tags || [];
        contentItem.type = ContentItemType.Video;

        contentItem.answers = [];
        const answer: IAnswer = new Answer();
        answer.convoId = state.convo.id;
        contentItem.answers.push(answer);

        return contentItem;
    }
}
